<div
  [ngStyle]="{ width: '100px', height: '100px' }"
  class="u-position-relative"
  fxLayout="row"
  fxLayoutAlign="center center"
>
  <div class="u-position-absolute" [ngStyle]="{ top: '1px', left: '1px' }">
    <div class="u-position-absolute">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="0"
        height="0"
        viewBox="0 0 0 0"
      >
        <linearGradient id="linearColors" x1="1" y1="0" x2="0" y2="0.5">
          <stop stop-color="#1EBCA0" offset="0%" />
          <stop stop-color="#1EBCA0" offset="40%" />
          <stop stop-color="#5E81E5" offset="100%" />
        </linearGradient>
      </svg>
    </div>
    <mat-progress-spinner
      class="mat-progress-spinner--gradient"
      mode="determinate"
      [value]="100"
      [strokeWidth]="14"
      [diameter]="98"
      aria-label="Progress indicator"
      i18n-aria-label="@@segmentedSpinner.progressIndicatorLabel"
    ></mat-progress-spinner>
  </div>
  <div *ngFor="let segment of segments; let index = index">
    <div
      *ngIf="(completedSteps || 0) < index + 1"
      [ngStyle]="{
        top: 0,
        left: 0,
        'transform-origin': '50%',
        transform:
          'rotate(' +
          ((index * (360 * (100 / segments.length / 100))) % 360) +
          'deg)',
      }"
      class="u-position-absolute"
    >
      <mat-progress-spinner
        mode="determinate"
        [value]="100 / segments.length"
        [strokeWidth]="16"
        class="mat-progress-spinner--grey100"
        aria-label="Progress indicator"
        i18n-aria-label="@@segmentedSpinner.progressIndicatorLabel"
      ></mat-progress-spinner>
    </div>
  </div>
  <div *ngFor="let segment of segments; let index = index">
    <div
      [ngStyle]="{
        top: 0,
        left: 0,
        'transform-origin': '50%',
        transform:
          'rotate(' +
          ((index * (360 * (100 / segments.length / 100))) % 360) +
          'deg)',
      }"
      class="u-position-absolute"
    >
      <mat-progress-spinner
        mode="determinate"
        [value]="1"
        [strokeWidth]="16"
        class="u-display-block mat-progress-spinner--white"
        aria-label="Progress indicator"
        i18n-aria-label="@@segmentedSpinner.progressIndicatorLabel"
      ></mat-progress-spinner>
    </div>
  </div>
  <p class="text-subtitle-1">{{ completedSteps || 0 }}/{{ segments.length }}</p>
</div>
